(() => {
  const escapeHtml = (value) =>
    String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const parseJsonFromEl = (el) => {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch {
      return null;
    }
  };

  const formatShadeTitleHtml = (rawTitle) => {
    const input = String(rawTitle || '').trim();
    if (!input) return '';
    const title = input.toLowerCase();

    const spacedDash = title.match(/\s[-–]\s/);
    if (spacedDash && typeof spacedDash.index === 'number') {
      const sep = spacedDash[0];
      const i = spacedDash.index;
      const left = title.slice(0, i).trim();
      const right = title.slice(i + sep.length).trim();
      return right
        ? `<strong>${escapeHtml(left)}</strong>${escapeHtml(sep)}<span class="shade-rest">${escapeHtml(right)}</span>`
        : `<strong>${escapeHtml(left)}</strong>`;
    }

    const i = title.search(/[-–]/);
    if (i === -1) return `<span class="shade-rest">${escapeHtml(title)}</span>`;
    const left = title.slice(0, i).trim();
    const sep = ` ${title[i]} `;
    const right = title.slice(i + 1).trim();
    return right
      ? `<strong>${escapeHtml(left)}</strong>${escapeHtml(sep)}<span class="shade-rest">${escapeHtml(right)}</span>`
      : `<strong>${escapeHtml(left)}</strong>`;
  };

  const formatMoneyFromCents = (cents) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || window.Shopify?.currency?.default || 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(value);
    } catch {
      return `€ ${value % 1 === 0 ? value.toFixed(0) : value.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')}`;
    }
  };

  const applyBundleDiscount = (baseTotal) => Math.round(Number(baseTotal || 0) * 0.85);

  const getCart = () => document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  const getAddUrl = () => {
    if (typeof routes !== 'undefined' && routes.cart_add_url) return routes.cart_add_url;
    if (window.Shopify?.routes?.root) return `${window.Shopify.routes.root}cart/add.js`;
    return '/cart/add.js';
  };

  const getConfig = () => {
    if (typeof fetchConfig === 'function') return fetchConfig('javascript');
    return { method: 'POST', headers: { Accept: 'application/json' } };
  };

  const renderModalProduct = (product, index) => {
    const title = escapeHtml(product?.title || '');
    const img = product?.image ? `<img src="${escapeHtml(product.image)}" alt="${title}" loading="lazy" width="64" height="64">` : '';

    const swatches = (product?.swatches || [])
      .filter((s) => s && s.variantId)
      .map((s, sIdx) => {
        const isAvailable = Boolean(s.available);
        const style = s.swatchImage
          ? `background-image:url(${escapeHtml(s.swatchImage)});background-size:cover;background-position:center;`
          : `background:${escapeHtml(s.swatchValue || '#1a1410')};`;
        const disabled = isAvailable ? '' : 'disabled';
        const dataTitle = escapeHtml(s.title || s.value || '');
        return `
          <button type="button" class="bundle-modal__swatch" data-product-index="${index}" data-swatch-index="${sIdx}" data-variant-id="${escapeHtml(s.variantId)}" data-variant-title="${dataTitle}" data-price="${escapeHtml(s.price)}" data-compare="${escapeHtml(s.compareAt)}" ${disabled} aria-label="${dataTitle}">
            <span class="bundle-modal__swatch-inner" style="${style}"></span>
          </button>
        `;
      })
      .join('');

    return `
      <div class="bundle-modal__product" data-product-index="${index}">
        <div class="bundle-modal__product-img">${img}</div>
        <div>
          <span class="bundle-modal__label">farbe für: ${title.toLowerCase()}</span>
          <p class="bundle-modal__shade" data-shade-text>bitte farbe auswählen</p>
          <div class="bundle-modal__swatches" data-swatches>${swatches}</div>
        </div>
      </div>
    `;
  };

  class BundleSection {
    constructor(sectionEl) {
      this.sectionEl = sectionEl;
      this.sectionId = sectionEl.dataset.sectionId;
      this.sliderEl = sectionEl.querySelector(`#BundleSlider-${this.sectionId}`);
      this.scrollbarEl = sectionEl.querySelector(`#BundleScrollbar-${this.sectionId}`);
      this.prevBtn = sectionEl.querySelector(`#BundleNavPrev-${this.sectionId}`);
      this.nextBtn = sectionEl.querySelector(`#BundleNavNext-${this.sectionId}`);
      this.modalEl = sectionEl.querySelector(`#BundleModal-${this.sectionId}`);
      this.modalBodyEl = this.modalEl?.querySelector('[data-bundle-modal-body]');
      this.modalTitleEl = this.modalEl?.querySelector(`#BundleModalTitle-${this.sectionId}`);
      this.confirmBtn = this.modalEl?.querySelector('[data-bundle-confirm]');
      this.confirmPriceEl = this.modalEl?.querySelector('[data-bundle-confirm-price]');

      this.active = null;
      this.selectedByProduct = new Map();
      this.selectionsByBlock = new Map();

      this.initSlider();
      this.bindEvents();
    }

    initSlider() {
      if (!this.sliderEl || typeof Swiper === 'undefined') return;

      const updateNav = (swiper) => {
        if (!this.prevBtn || !this.nextBtn) return;
        const s = swiper || this.swiper;
        if (!s) return;

        if (s.isLocked) {
          this.prevBtn.setAttribute('disabled', '');
          this.nextBtn.setAttribute('disabled', '');
          return;
        }

        if (s.isBeginning) this.prevBtn.setAttribute('disabled', '');
        else this.prevBtn.removeAttribute('disabled');

        if (s.isEnd) this.nextBtn.setAttribute('disabled', '');
        else this.nextBtn.removeAttribute('disabled');
      };

      const options = {
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false,
        scrollbar: {
          el: this.scrollbarEl,
          draggable: true,
        },
        navigation:
          this.prevBtn && this.nextBtn
            ? {
                prevEl: this.prevBtn,
                nextEl: this.nextBtn,
              }
            : undefined,
        breakpoints: {
          750: { slidesPerView: 2.2, spaceBetween: 20 },
          990: { slidesPerView: 3.5, spaceBetween: 20 },
        },
        on: {
          init: (swiper) => updateNav(swiper),
          slideChange: (swiper) => updateNav(swiper),
          reachEnd: (swiper) => updateNav(swiper),
          fromEdge: (swiper) => updateNav(swiper),
          resize: (swiper) => updateNav(swiper),
        },
      };

      this.swiper = new Swiper(this.sliderEl, options);
      updateNav(this.swiper);
    }

    bindEvents() {
      this.sectionEl.addEventListener('click', (e) => {
        const openBtn = e.target.closest('.js-bundle-open');
        if (openBtn) {
          e.preventDefault();
          const blockId = openBtn.dataset.bundleOpen;
          if (!blockId) return;
          this.openModalForBlock(blockId);
          return;
        }

        const closeBtn = e.target.closest('.js-bundle-close');
        if (closeBtn) {
          e.preventDefault();
          this.closeModal();
          return;
        }

        const swatchBtn = e.target.closest('.bundle-modal__swatch');
        if (swatchBtn) {
          e.preventDefault();
          this.handleSwatchClick(swatchBtn);
          return;
        }

        const confirmBtn = e.target.closest('[data-bundle-confirm]');
        if (confirmBtn) {
          e.preventDefault();
          this.confirmBundleAdd();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (!this.modalEl?.classList.contains('is-open')) return;
        this.closeModal();
      });
    }

    getBlockEl(blockId) {
      return this.sectionEl.querySelector(`[data-bundle-block-id="${CSS.escape(blockId)}"]`);
    }

    getBundleData(blockId) {
      const blockEl = this.getBlockEl(blockId);
      if (!blockEl) return null;
      const jsonEl = blockEl.querySelector('.js-bundle-data');
      return parseJsonFromEl(jsonEl);
    }

    openModalForBlock(blockId) {
      const data = this.getBundleData(blockId);
      if (!data || !this.modalEl || !this.modalBodyEl || !this.confirmBtn) return;

      this.active = { blockId, data };
      this.selectedByProduct = new Map();

      if (this.modalTitleEl) this.modalTitleEl.textContent = data.title || 'Set anpassen';
      this.modalBodyEl.innerHTML = (data.products || []).map(renderModalProduct).join('');

      const prev = this.selectionsByBlock.get(blockId);
      if (prev) {
        for (const [idx, v] of prev.entries()) {
          const btn = this.modalBodyEl.querySelector(`.bundle-modal__swatch[data-product-index="${idx}"][data-variant-id="${CSS.escape(String(v.variantId))}"]`);
          if (btn) this.applySelection(btn, { updateTotals: false });
        }
      }

      this.updateConfirmPrice();
      this.updateConfirmState();
      document.body.classList.add('modal-open');
      this.modalEl.classList.add('is-open');
      this.modalEl.setAttribute('aria-hidden', 'false');
    }

    closeModal() {
      if (!this.modalEl) return;
      this.modalEl.classList.remove('is-open');
      this.modalEl.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('modal-open');
      this.active = null;
      this.selectedByProduct = new Map();
    }

    handleSwatchClick(btn) {
      if (!btn || btn.hasAttribute('disabled')) return;
      this.applySelection(btn, { updateTotals: true });
      this.updateConfirmState();
    }

    applySelection(btn, { updateTotals }) {
      const productIndex = Number(btn.dataset.productIndex);
      if (Number.isNaN(productIndex)) return;

      const productEl = this.modalBodyEl.querySelector(`.bundle-modal__product[data-product-index="${productIndex}"]`);
      if (!productEl) return;

      productEl.querySelectorAll('.bundle-modal__swatch').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      const variantId = btn.dataset.variantId;
      const title = btn.dataset.variantTitle || '';
      const price = Number(btn.dataset.price || 0);
      const compare = Number(btn.dataset.compare || 0);

      const shadeText = productEl.querySelector('[data-shade-text]');
      if (shadeText) {
        if (title) shadeText.innerHTML = formatShadeTitleHtml(title);
        else shadeText.textContent = 'bitte farbe auswählen';
        if (title) shadeText.classList.add('is-set');
        else shadeText.classList.remove('is-set');
      }

      this.selectedByProduct.set(productIndex, { variantId, title, price, compare });

      if (updateTotals) this.updateCardTotals();
    }

    updateCardTotals() {
      if (!this.active) return;
      const { blockId } = this.active;
      const blockEl = this.getBlockEl(blockId);
      if (!blockEl) return;

      const totals = this.getTotalsFromSelection();
      if (!totals) return;

      const priceEl = blockEl.querySelector('[data-bundle-total-price]');
      const compareEl = blockEl.querySelector('[data-bundle-total-compare]');
      const saveEl = blockEl.querySelector('[data-bundle-save-percent]');

      if (priceEl) {
        priceEl.dataset.bundleTotalPrice = String(totals.total);
        priceEl.textContent = formatMoneyFromCents(totals.total);
      }

      if (compareEl) {
        compareEl.dataset.bundleTotalCompare = String(totals.compare);
        if (totals.compare > totals.total) {
          compareEl.style.display = '';
          compareEl.textContent = formatMoneyFromCents(totals.compare);
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (saveEl) {
        saveEl.dataset.bundleSavePercent = '15';
        if (Number(totals.compare || 0) > 0) {
          saveEl.style.display = '';
          saveEl.textContent = 'SAVE 15%';
        } else {
          saveEl.style.display = 'none';
        }
      }

      this.updateConfirmPrice(totals.total);
    }

    getTotalsFromSelection() {
      if (!this.active) return null;
      const products = this.active.data?.products || [];
      if (!products.length) return null;

      let compare = 0;

      for (let i = 0; i < products.length; i++) {
        const sel = this.selectedByProduct.get(i);
        if (!sel) return null;
        compare += Number(sel.price || 0);
      }

      return { total: applyBundleDiscount(compare), compare };
    }

    updateConfirmState() {
      if (!this.active || !this.confirmBtn) return;
      const products = this.active.data?.products || [];
      const isComplete = products.length > 0 && this.selectedByProduct.size === products.length && [...this.selectedByProduct.values()].every((v) => v && v.variantId);
      this.confirmBtn.disabled = !isComplete;
    }

    updateConfirmPrice(totalCents) {
      if (!this.confirmPriceEl || !this.active) return;

      let cents = totalCents;
      if (typeof cents === 'undefined' || cents === null) {
        const blockEl = this.getBlockEl(this.active.blockId);
        const priceEl = blockEl?.querySelector('[data-bundle-total-price]');
        if (priceEl) cents = Number(priceEl.dataset.bundleTotalPrice || 0);
      }

      this.confirmPriceEl.textContent = formatMoneyFromCents(cents || 0);
    }

    async confirmBundleAdd() {
      if (!this.active || !this.confirmBtn || this.confirmBtn.disabled) return;
      const totals = this.getTotalsFromSelection();
      const products = this.active.data?.products || [];
      if (!totals || !products.length) return;

      if (this.confirmBtn.classList.contains('loading')) return;
      this.confirmBtn.classList.add('loading');
      const spinner = this.confirmBtn.querySelector('.loading__spinner');
      const text = this.confirmBtn.querySelector('.bundle-modal__confirm-text');
      if (spinner) spinner.classList.remove('hidden');
      if (text) text.classList.add('hidden');

      this.confirmBtn.disabled = true;
      this.confirmBtn.setAttribute('aria-disabled', 'true');

      const bundleId = `bundle_${Date.now()}_${Math.random().toString(16).slice(2)}`;
      const bundleProductTitle = String(this.active.data?.title || '').trim();
      const bundleSetTitle = String(this.active.data?.subtitle || '').trim();
      const bundleSize = Number(this.active.data?.bundleSize || products.length) || products.length;
      const discountTotal = Math.max(0, Number(totals.compare || 0) - Number(totals.total || 0));
      const discountPerItem = bundleSize > 0 ? Math.floor(discountTotal / bundleSize) : 0;

      const items = [];
      for (let i = 0; i < products.length; i++) {
        const sel = this.selectedByProduct.get(i);
        if (!sel?.variantId) continue;
        const existing = items.find((x) => String(x.id) === String(sel.variantId));
        if (existing) existing.quantity += 1;
        else items.push({ id: sel.variantId, quantity: 1 });
      }


      if (window.RevyBundle && window.RevyBundle.api && window.RevyBundle.api.setGroup) {
        console.log("RevyBundleGroup: Setting RevyBundle group");
        const groupIds = items.flatMap((item) => Array(item.quantity).fill(item.id));
        if (groupIds.length >= 2) {
          const saved = await window.RevyBundle.api.setGroup(...groupIds);
          console.log("RevyBundleGroup: Set:", saved);
          console.log(window.RevyBundle.api.getBundleInfo());
        }
      }

      try {
        let lastResponseJson = null;
        const cart = getCart();
        const addUrl = getAddUrl();

        for (const item of items) {
          const config = getConfig();
          config.headers = config.headers || {};
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData();
          formData.append('id', item.id);
          formData.append('quantity', item.quantity);
          formData.append('properties[_bundle_id]', bundleId);
          formData.append('properties[_bundle_product_title]', bundleProductTitle);
          formData.append('properties[_bundle_set_title]', bundleSetTitle || 'SET');
          formData.append('properties[_bundle_size]', String(bundleSize));
          formData.append('properties[_bundle_discount_cents_per_item]', String(discountPerItem));

          if (cart && typeof cart.getSectionsToRender === 'function') {
            formData.append(
              'sections',
              cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(this.confirmBtn);
          }

          config.body = formData;
          const res = await fetch(addUrl, config);
          lastResponseJson = await res.json();
          if (lastResponseJson?.status) throw new Error(lastResponseJson.description || 'Failed to add to cart');
        }

        if (!lastResponseJson) throw new Error('Failed to add to cart');

        if (cart && typeof cart.renderContents === 'function' && lastResponseJson.sections) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-section', cartData: lastResponseJson });
          }
          cart.renderContents(lastResponseJson);
        } else if (document.querySelector('cart-drawer')) {
          const res = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble&t=${Date.now()}`);
          const sections = await res.json();
          document.querySelector('cart-drawer')?.renderContents({ sections, item_count: 1 });
        }

        this.selectionsByBlock.set(this.active.blockId, new Map(this.selectedByProduct));
        this.closeModal();
      } catch (e) {
        alert('There was an error adding items to the cart. Please try again.');
      } finally {
        this.confirmBtn.removeAttribute('aria-disabled');
        this.confirmBtn.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        if (text) text.classList.remove('hidden');
        this.updateConfirmState();
      }
    }
  }

  const init = () => {
    document.querySelectorAll('[data-bundle-section]').forEach((el) => {
      if (el.__bundleSectionInit) return;
      el.__bundleSectionInit = true;
      new BundleSection(el);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
